import List from 'list.js'

jQuery(document).ready(function(e) {


    if(jQuery('.page-template-dinning').length > 0){

        var options = {
            valueNames: [ 'category' ]
        };

        var postList = new List('post-list', options);

        // Get the query parameter value
        var urlParams = new URLSearchParams(window.location.search);
        var type = urlParams.get('type');

        // Set the selected option based on the query parameter
        if (type === 'drinking') {
            jQuery('#dining-drinking-filter').val('drinking').select2();
        } else if (type === 'dining') {
            jQuery('#dining-drinking-filter').val('dining').select2();
        } else {
            jQuery('#dining-drinking-filter').val('').select2();
        }

        // Function to filter the list based on the selected option
        function filterList() {
            var filterValue = jQuery('#dining-drinking-filter').val();

            if (filterValue) {
                postList.filter(function(item) {
                    return item.values().category === filterValue;
                });
            } else {
                postList.filter();
            }
        }

        // Trigger the filtering on page load
        filterList();

        // Filter the list when the select value changes
        jQuery('#dining-drinking-filter').on('change', function() {
            filterList();
        });

    }

});
